import api from '../../api'

export default function getOffersAnalytics(brandId) {
  return api.get(`/brands/manage/${brandId}/offers/analytics`);
}